/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:17:40
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-08-29 17:50:20
 * @FilePath: \app-client-h5\src\pages\rechargeWater\index.jsx
 */
import React, { Component } from 'react';

import {
    Form,
    Modal,
    Button,
    Selector,
    Toast,
    List,
    Popup
} from 'antd-mobile';
import { getTemplate, rechargePay, count, sendH5PayRequest, getPayResult } from "./services";
import { getNewData } from "../../utils/util"

import './index.scss'
class RechargeWater extends Component {
    ref = React.createRef();
    formRef = React.createRef();
    constructor(props) {
        super(props)
        this.state = {
            arrow: require('../../assets/arrow.png'),
            wechat: require('../../assets/wechat-icon.png'),
            waterIcon: require('../../assets/waterIcon.png'),
            priceIcon: require('../../assets/priceIcon.png'),
            addressIcon: require('../../assets/addressIcon.png'),
            options: [

            ],
            template: '',
            rechargeRoom: '',
            rechargeMoney: '',
            def: [],
            payVisible: false,
            alertShow:false
        }
    }
    componentWillUnmount(){
        this.setState({alertShow:false});
        let dom = document.querySelector('.adm-modal');
        if (dom) {
            dom.style.display = 'none';
        }
    }
    componentDidMount() {
        document.title = '买水'
        this.setState({
            rechargeRoom: JSON.parse(localStorage.getItem('roomData'))
        })
        this.getTemplate()
    }
    getTemplate = () => {
        getTemplate().then((res) => {
            if (res.code == '200') {
                let sortNumber = (res.data.rechargeOptions).sort(function (a, b) { return a - b });;
                let arr = []
                sortNumber.forEach((item, k) => {
                    let obj = {
                        label: item,
                        value: item,
                        description: '吨',
                    }
                    arr.push(obj)
                })
                this.setState({
                    template: res.data,
                    options: arr,
                    def: [arr[0].value],

                })
            } else {
                Toast.show({
                    content: res.message,
                })
            }
        }).catch((err) => {
            Toast.show({
                content: '系统错误',
            })
        })
    }
    selectMoney(arr) {
        this.setState({
            rechargeMoney: arr.toString()
        })
    }
    handleAlert = () => {
        this.setState({ payVisible: true })
    }
    gobuy = () => {//下单
        this.setState({ payVisible: false })
        const { rechargeMoney, def, template } = this.state;
        const { optionFeeArray } = template;
        let params = { waterNum: '', rechargeMoney: '' };
        if (rechargeMoney == '') {//默认第一项
            params.waterNum = optionFeeArray[0].option;
            params.rechargeMoney = optionFeeArray[0].totalMoney;
        } else {
            optionFeeArray.forEach((v, i) => {
                if (v.option == rechargeMoney) {
                    params.waterNum = v.option;
                    params.rechargeMoney = v.totalMoney;
                }
            })
        }
        rechargePay(params).then((res) => {
            if (res.code == 200) {
                const data = res.data;
                sendH5PayRequest({ nwebUrl: data.codeUrl }).then((res) => {
                    if (res.code == 200) {
                        window.location.href = res.data;
                        console.log(res);
                        setTimeout(() => {
                            this.renderModal(data.outTradeNo)
                        },3000)
                    } else {
                        Toast.show({
                            content: res.message,
                        })
                    }
                })
            } else {
                Toast.show({
                    content: res.message,
                })
            }
        })
    }
    renderRechargeWater() {
        const { options, waterIcon, template, rechargeMoney, def } = this.state;
        if (def.length == 0) {
            return;
        }
        return (
            <div className="middle-box">
                <div className='middle-box-top'>
                    <img className="icon" src={waterIcon} />
                    <span>充水水量</span>
                </div>
                <div className="selector-box">
                    <Selector
                        style={{
                            '--border-radius': '0.18rem',
                            '--border': 'solid #DDDDDD 1px',
                            '--checked-border': 'solid var(--adm-color-primary) 1px',
                            with: '100%',
                        }}
                        columns={3}
                        showCheckMark={false}
                        options={options}
                        defaultValue={def}
                        onChange={(arr, extend) => this.selectMoney(arr)}
                    />
                </div>

                <div className='number-box'>
                    <div className="money-box">
                        <span className='symbol'>￥</span>
                        {/* <span className='money'>{rechargeMoney*template.unitPrice}</span> */}
                        {
                            template.optionFeeArray.map((item, index) => {
                                if (!rechargeMoney && index == 0) {
                                    return <span key={index} className='money'>{template.optionFeeArray[0].totalMoney}</span>
                                }
                                return (
                                    <>
                                        {rechargeMoney == item.option && <span key={index} className='money'>{item.totalMoney}</span>}
                                    </>

                                )
                            })
                        }
                    </div>
                    <div className='text'>
                        <div>注意：购买的水量实际生效会有延迟，</div>
                        <div>需要等到该设备下一次更新数据时才能执行到水表里</div>
                    </div>
                    {/* <div className='time'>
                        今日下单预计执行到水表时间为：<span>{estimatedExecTime}</span>
                    </div> */}
                </div>
            </div>
        )
    }
    renderModal = (outTradeNo) => {
        return Modal.show({
            content: '请确认微信支付是否已完成',
            closeOnAction: true,
            actions: [
                {
                    key: 'paySuccess',
                    text: '已支付完成',
                    primary: true,
                    onClick: () => {
                        getPayResult({ outTradeNo }).then((res) => {
                            console.log(res);
                            if (res.code == 200) {
                                if (res.data.payCode==1) {
                                    this.props.history.push('/rechargeResult?orderNo='+outTradeNo)
                                }
                                if (res.data.payCode==0) {
                                    Toast.show({
                                        content: res.data.codeDesc,
                                    })
                                }
                            } else {
                                Toast.show({
                                    content: res.message,
                                })
                            }
                        })
                    }
                },
                {
                    key: 'noPay',
                    text: '支付遇到问题，重新下单',
                },
            ],
        })
    }

    render() {
        const { addressIcon, priceIcon, rechargeRoom, template, payVisible, arrow, wechat } = this.state;
        return (
            <div className='rechargeWater-container'>
                <Popup
                    visible={payVisible}
                    onMaskClick={() => {
                        this.setState({ payVisible: false })
                    }}
                    bodyStyle={{ height: '2rem' }}
                >
                    <div className='payTit'>请选择支付方式</div>
                    <div className='payList'>
                        <div className='payItem' onClick={this.gobuy}>
                            <span><img className='payIcon' src={wechat} />微信支付</span>
                            <span>{">"}</span>
                        </div>
                    </div>

                </Popup>
                <div className='top-box'>
                    <div className='top-box-top'>
                        <span className="c6 span-position"> <img className="icon" src={addressIcon} />充水房间：</span>
                        <span className="c3">{rechargeRoom.projectName || '--'}<span className='verLine'>|</span>{rechargeRoom.room || '--'}</span>
                    </div>
                    <div className='top-box-bottom'>
                        <img className="icon" src={priceIcon} />
                        <span className="c6">水单价：</span><span className="c3">{template.unitPrice}元/吨</span>
                    </div>
                </div>
                {this.renderRechargeWater()}
                <div>
                    {/* <Button block shape='rounded' color='' className='submit-btn' onClick={this.gobuy}>下单</Button> */}
                    <Button block shape='rounded' color='' className='submit-btn' onClick={this.handleAlert}>下单</Button>
                </div>
            </div>


        )
    }
}
export default RechargeWater;

